import React from "react";
import styles from "../TermsOf/TermsOf.module.css";
import FooterBottom from "../../Footer2/FooterBottom";
const TermsOf = () => {
  return (
    <>
      <div className={styles.LogoDIv}
        onClick={() => (window.location.href = "https://www.brunovisioncare.com/")}
        style={{ cursor: "pointer" }}>
        <div className={styles.LogImg}>
          <img src="Images/Logo-svg2.png" alt="Bruno Vision Care logo" loading="lazy" decoding="async" />
        </div>
      </div>
      <section className={styles.mainPriva}>
        <h1>Terms of Use </h1>
        <div className={styles.paraStart}>
          <p>Effective Date: September 1, 2025</p>
          <p>
            These Terms of Use <b>(“Terms”)</b> set forth a legally binding
            agreement between you and Bruno Vision Care, LLC <b>(“BVC”)</b>,
            governing your use of the BVC website,
            <a href="https://www.brunovisioncare.com" target="_blank" rel="noopener noreferrer">
              {" "}
              www.brunovisioncare.com
            </a>{" "}
            <b>(“Site”)</b>.
          </p>
          <p>
            By using the Site, you agree to be bound by these Terms. If you use
            the Site on behalf of a company, business, or other entity, then (1)
            the term <b>“you”</b> includes you and such company, business, or
            entity, and (2) you represent and warrant that: (a) you are authorized
            to bind such company, business, or entity to these Terms and (b) you
            agree to these Terms on such company’s, business’s, or entity’s
            behalf.
          </p>

          <h2>
            PLEASE READ THESE TERMS CAREFULLY BEFORE ACCESSING OR USING THE SITE.
            THESE TERMS AFFECT YOUR LEGAL RIGHTS, INCLUDING BY LIMITING BVC’S
            LIABILITY, WAIVING YOUR RIGHT TO TRIAL BY JURY, AND WAIVING YOUR RIGHT
            TO PARTICIPATE IN A CLASS ACTION OR COLLECTIVE ACTION LAWSUIT, AS SET
            OUT IN MORE DETAIL IN SECTION 11 BELOW.
          </h2>
          <div className={styles.DivBold}>
            {" "}
            <b>
              By accessing or using the Site, you attest that you are at least the
              age of majority in your state or province of residence and are
              legally capable of entering into a binding contract. If you do not
              agree to be bound by these Terms, you must not access or use the
              Site.
            </b>
          </div>

          <h5>1. Sale Agreements</h5>
          <p>
            You and BVC may have entered or may enter into one or more written
            agreements related to your purchase of products and/or services from
            BVC <b>(“Sale Agreements”)</b>. TO THE EXTENT THAT YOU HAVE ONE OR
            MORE SALE AGREEMENTS, YOU AGREE TO ABIDE BY SUCH SALE AGREEMENTS WITH
            RESPECT TO THE PURCHASE OF PRODUCTS AND<span>/</span>OR SERVICES FROM
            BVC, EVEN IF SUCH PRODUCTS AND <span>/</span>OR SERVICES ARE
            REFERENCED OR ADVERTISED ON THE SITE. IN THE EVENT OF A CONFLICT
            BETWEEN ANY SALE AGREEMENT AND THESE TERMS, THE SALE AGREEMENT SHALL
            GOVERN AND CONTROL WITH RESPECT TO YOUR USE OF THAT PORTION OF THE
            SITE OR THE SPECIFIC PRODUCT OR SERVICE OFFERED.
          </p>

          <h5>2. Privacy</h5>
          <p>
            You agree that personal information that you provide through the Site
            shall be governed by our <a href="/privacy-and-cookie-policy">Privacy and Cookie Policy</a>,
            which is hereby incorporated and made part of these Terms. By using
            the Site, you consent to all actions taken by us with respect to your
            personal information in compliance with the Privacy Policy, which may
            be modified and amended from time to time without notice.
          </p>

          <h5>3. Site Access and Use</h5>
          <p>
            You may access and use the Site solely for lawful, internal business,
            noncommercial, personal purposes. The Site is the sole property of
            BVC, and is provided to you without charge as a convenience and for
            your informational purposes only. You agree to use the Site only for
            the purposes for which we provide the Site and in accordance with
            these Terms. BVC reserves the right to deny use or access to any part
            of the Site at our sole discretion.
          </p>

          <h5>
            <span>4.</span> Intellectual Property{" "}
          </h5>

          <p>
            The Site may contain: (1) materials and other items relating to BVC
            and its services,including software, layout, information, databases,
            articles, posts, text, data, files, images,scripts, designs, graphics,
            instructions, illustrations, photographs, sounds, pictures,
            videos,advertising copy, URLs, technology, and the “look and feel” of
            the Site; (2) logos, service marks, trademarks, trade names, trade
            dress, and trade identities of various parties, including those of
            BVC; and (3) other forms of intellectual property (collectively{" "}
            <b>“Content”</b>).
          </p>
          <p>
            All Content is the property of BVC, its licensors, or other providers
            of such Content and is protected by copyright, trademark, patent,
            trade secret, and other intellectual property or proprietary rights
            laws. You do not have any ownership rights to the Site or any of its
            Content. All rights in and to the Site and its Content not expressly
            granted in this provision remain with BVC, our licensors, and other
            Content providers.
          </p>

          <p>
            You must not: (1) modify copies of any Content from the Site; (2) use
            any illustrations, photographs, video or audio sequences, or any
            graphics separately from the accompanying text; nor (3) delete or
            alter any copyright, trademark, or other proprietary rights notices
            from copies of Content from the Site.
          </p>
          <p>
            If you print, copy, modify, or download Content in breach of these
            Terms, your right to use the Site will stop immediately and you must,
            at our option, return, or destroy any copies of the Content you have
            made.
          </p>

          <h5>5. Restrictions</h5>
          <p>
            You may only access or use the Site or any services or Content
            available through the Site for lawful purposes and as authorized by
            BVC. You must not:
          </p>
          <ul>
            <li>
              Use the Site in any way that violates local, state, national, or
              foreign laws;
            </li>
            <li>
              Engage in activity using or related to the Site or its Content that
              is unlawful, harmful, defamatory, tortious, libelous, offensive,
              obscene, violent, threatening, harassing, abusive, or otherwise
              objectionable to BVC;
            </li>
            <li>
              Attempt to disable, hack, or otherwise interfere with the Site’s
              functions;
            </li>
            <li>
              Harvest, scrape, reverse engineer, derive a work, or modify any
              information from the Site or its Content;
            </li>
            <li>
              Transmit any software or other materials that contain any viruses,
              worms, Trojan horses, defects, or other rogue programming or items
              of a destructive nature;
            </li>
            <li>
              Attempt to bypass or circumvent any measures that BVC has put in
              place to restrict or prevent access all or parts of the Site;
            </li>
            <li>
              Infringe any intellectual property rights of BVC or any third party;
            </li>
            <li>
              Use the Site or its Content to suggest an unauthorized association
              with BVC;
            </li>
            <li>
              Pose as another person or otherwise misrepresent your identity;
            </li>
            <li>
              Change or delete any proprietary notices from Content downloaded or
              printed out from the Site;
            </li>
            <li>
              Use, copy, download, reproduce, republish, distribute, transmit,
              broadcast, display,assign, license, sublicense, sell, alter, prepare
              derivative works of, or otherwise exploit the Site and/or Content
              (in whole or in part) without BVC’s prior, express, and written
              permission;
            </li>
            <li>
              Send, knowingly receive, upload, download, use, or re-use any
              Content in a manner that does not comply with these Terms; nor
            </li>
            <li>Otherwise violate these Terms.</li>
          </ul>
          <p>
            You must comply with all applicable laws and legal obligations,
            including those pertaining to such areas as: copyright, trademark,
            other intellectual property laws, libel, slander, defamation, trade
            libel, product disparagement, harassment, invasion of privacy, tort,
            obscenity, indecency, and copyright or trademark infringement.
            Violations of applicable laws may give rise to civil and/or criminal
            prosecution and penalties.
          </p>

          <h5>6. External Services</h5>

          <p>
            The Site may contain links to third-party websites, features, or other
            online platforms (collectively, the <b>“External Services”</b>
            ). BVC does not control, review, endorse, or take responsibility for
            the content or data practices of External Services, nor does BVC make
            any representation or warranty regarding the accuracy of such content.
            If you decide to access any of the External Services linked to the
            Site, you do so entirely at your own risk. BVC is neither responsible
            nor liable for any loss or damage as a result of any use of External
            Services.
          </p>

          <h5>7. Disclaimers</h5>
          <p>
            THE SITE AND CONTENT ARE PROVIDED BY BVC ON AN “AS IS” AND “AS
            AVAILABLE” BASIS, AND WITHOUT WARRANTY OF ANY KIND, EITHER EXPRESS OR
            IMPLIED, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
            TITLE, NON-INFRINGEMENT, SATISFACTORY QUALITY, RELIABILITY, ACCURACY,
            MERCHANTABILITY, AND FITNESS FOR A PARTICULAR PURPOSE. THIS ALSO
            INCLUDES ANY WARRANTIES THAT MAY ARISE FROM ANY COURSE OF DEALING,
            COURSE OF PERFORMANCE, OR USAGE OF TRADE.
          </p>
          <p>
            BVC MAKES NO REPRESENTATIONS OR WARRANTIES ABOUT THE SITE OR CONTENT.
            BVC DOES NOT WARRANT OR GUARANTEE THE ACCURACY, COMPLETENESS,
            CORRECTNESS, TIMELINESS, OR USEFULNESS OF THE SITE AND/OR ITS CONTENT.
            BVC DOES NOT WARRANT THAT YOUR USE OF THE SITE OR CONTENT WILL BE
            UNINTERRUPTED, ERROR-FREE, OR SECURE; THAT DEFECTS WILL BE CORRECTED;
            OR THAT THE SITE, THE SERVER(S) ON WHICH THE SITE IS HOSTED, OR
            CONTENT ARE SECURE OR FREE FROM VIRUSES OR OTHER HARMFUL COMPONENTS.
            BVC ASSUMES NO RESPONSIBILITY FOR ANY LOSS OR HARM THAT OCCURS
            RESULTING FROM ANY USE OF THE SITE OR CONTENT. YOUR USE OF THE SITE
            AND CONTENT IS SOLELY AT YOUR OWN RISK.
          </p>

          <p>
            IF APPLICABLE LAW DOES NOT ALLOW THE EXCLUSION OF SOME OR ALL OF THE
            IMPLIED WARRANTIES CONTAINED IN THIS SECTION, THE EXCLUSIONS IN THIS
            SECTION WILL APPLY TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW.
          </p>

          <h5>8. Limitation of Liability</h5>
          <p>
            TO THE MAXIMUM EXTENT PERMITTED BY LAW, YOU AGREE THAT BVC AND ITS
            TRUSTEES, OFFICERS, DIRECTORS, EMPLOYEES, AGENTS, AND AFFILIATES
            (COLLECTIVELY, THE “BVC PARTIES”), WILL NOT BE LIABLE TO YOU OR ANY
            THIRD PARTY FOR ANY INJURY, LOSS, CLAIM, DAMAGE, OR ANY SPECIAL,
            EXEMPLARY, PUNITIVE, DIRECT, INDIRECT, INCIDENTAL, OR CONSEQUENTIAL
            DAMAGES OF ANY KIND (INCLUDING, BUT NOT LIMITED TO ECONOMIC LOSS,
            INDIRECT OR DIRECT LOST PROFITS, OR LOST SAVINGS), WHETHER BASED IN
            CONTRACT, TORT, EQUITY, STRICT LIABILITY, OR OTHERWISE, WHICH ARISES
            OUT OF OR IS IN ANY WAY CONNECTED WITH ANY USE OF THE SITE AND/OR ITS
            CONTENT, THE OPERATION OF THE SITE OR ANY FAILURE OR DELAY IN THE
            OPERATION OF THE SITE, OR ANY OF THE PRODUCTS OR SERVICES OFFERED ON
            THE SITE, EVEN IF ADVISED OF THE POSSIBILITY OF DAMAGES.
          </p>
          <p>
            BVC ASSUMES NO RESPONSIBILITY FOR ANY LOSS OR HARM THAT OCCURS
            RESULTING FROM YOUR USE OF THE SITE. YOUR USE OF THE SITE IS SOLELY AT
            YOUR OWN RISK. YOU UNDERSTAND THAT WE CANNOT AND DO NOT GUARANTEE OR
            WARRANT THAT FILES AVAILABLE FOR DOWNLOADING FROM THE INTERNET OR THE
            SITE WILL BE FREE OF VIRUSES OR OTHER DESTRUCTIVE CODE. YOU ARE
            RESPONSIBLE FOR IMPLEMENTING SUFFICIENT PROCEDURES AND CHECKPOINTS TO
            SATISFY YOUR PARTICULAR REQUIREMENTS FOR ANTI-VIRUS PROTECTION AND
            ACCURACY OF DATA.
          </p>
          <p>
            IF YOU ARE DISSATISFIED WITH ANY PORTION OF THE SITE, OR WITH ANY OF
            THESE TERMS, YOUR SOLE AND EXCLUSIVE REMEDY IS TO DISCONTINUE USING
            THE SITE. TO THE EXTENT ANY ASPECTS OF THE FOREGOING LIMITATIONS OF
            LIABILITY ARE NOT ENFORCEABLE, THE MAXIMUM AGGREGATE LIABILITY OF BVC
            TO YOU WITH RESPECT TO YOUR USE OF THE SITE IS $500 (FIVE HUNDRED
            DOLLARS).
          </p>

          <h5>9. Indemnification</h5>
          <p>
            In consideration for BVC permitting you to access and use the Site,
            you expressly defend, indemnify, and hold harmless the BVC Parties
            from any and all claims, liabilities, demands, causes of action,
            costs, expenses, and damages of every kind and nature, in law or
            equity, or otherwise, arising out of or in any way related to your
            access or use of the Site or Content, whether arising from negligence
            or any other acts or omissions by BVC.
          </p>
          <p>
            You will defend, indemnify, and hold harmless the BVC Parties from and
            against any loss, damage, judgment, settlement, expense, interest, and
            any other liability (including reasonable attorneys’ fees and costs)
            related to or arising out of any allegation, claim, lawsuit, or
            proceeding (a “Claim”) to the extent such Claim is based on your use
            or access of the Site or Content in connection with: (a) an
            infringement of any patent, trademark, copyright, trade secret, or
            other intellectual property right, including costs and expenses; (b)
            any breach of these Terms; (c) any unlawful, improper, or negligent
            use by anyone of the Site or Content; (d) any dispute between you and
            a third party in connection with the Site or Content; or (e) your
            negligence, willful misconduct, or fraud. You will use counsel
            reasonably satisfactory to us to defend each Claim. I
          </p>

          <p>
            Notwithstanding the foregoing, BVC retains the exclusive right to
            settle, compromise, and pay any and all Claims. BVC reserves the right
            to assume the exclusive defense and control of any Claims. You will
            not settle any Claims without, in each instance, the prior written
            consent of an officer of BVC.
          </p>

          <h5>10. Governing Law and Venue</h5>
          <p>
            These Terms shall be governed by, and enforced in accordance with, the
            substantive and procedural laws of the state of Florida, including its
            statute of limitations, and without regard to any conflicts of law
            provisions that might apply the laws of another jurisdiction. You
            expressly agree that all disputes arising under or relating to the
            Site or these Terms shall be brought and resolved solely and
            exclusively in Florida.{" "}
          </p>
          <h5>
            11. Dispute Resolution; Waiver of Right to a Jury Trial; Waiver of
            Right to Class and Collective Actions
          </h5>
          <p>
            In the event of a dispute between you and BVC regarding any Claim or
            controversy at law or equity arising out of, relating to, or connected
            in any way with the Site (<b>“Dispute”</b>), you agree that, before
            initiating any legal action, you will first provide us written notice
            (a <b>“Notice of Dispute”</b>) via email at{" "}
            <a
              href="https://mail.google.com/mail/u/0/?view=cm&to=legal@brunovisioncare.com"
              target="blank"
            >
              legal@brunovisioncare.com
            </a>{" "}
            or via postal mail at 5550 Glades Road Suite 500 Boca Raton, FL 33432
            so that we may work with you in good faith to find a
            mutually-agreeable solution. The Notice of Dispute will include (1) a
            written description of the problem with relevant documents and
            supporting information; and (2) a statement of the specific resolution
            you are seeking.
          </p>
          <p>
            During the 45 days from the date we receive your Notice of Dispute,
            both parties agree to (1) engage in good faith efforts to resolve the
            Dispute, and (2) toll any statutes of limitations that may apply,
            along with any filing deadlines.
          </p>
          <p>
            BVC will consider reasonable requests to resolve the Dispute through
            alternative dispute resolution procedures, such as mediation or
            arbitration, as alternatives to litigation.
          </p>
          <p>
            UNLESS OTHERWISE PROHIBITED BY APPLICABLE LAW, YOU WAIVE ANY RIGHT TO
            A JURY TRIAL AND YOU AGREE THAT ANY AND ALL DISPUTES (WHETHER BASED IN
            CONTRACT, STATUTE, TORT, OR ANY OTHER THEORY) WILL BE RESOLVED
            INDIVIDUALLY, WITHOUT RESORT TO ANY FORM OF CLASS ACTION, COLLECTIVE
            ACTION, OR REPRESENTATIVE ACTION. ALL CLAIMS MUST BE BROUGHT SOLELY IN
            A PARTY’S INDIVIDUAL CAPACITY, AND NOT AS A PLAINTIFF OR CLASS MEMBER
            IN ANY PURPORTED CLASS ACTION, COLLECTIVE ACTION, CONSOLIDATED ACTION,
            REPRESENTATIVE ACTION, OR PROCEEDING.
          </p>
          <p>
            To the fullest extent permitted by applicable law, you agree to assert
            any Dispute against us (by delivery of the Notice of Dispute) within
            one (1) year after the Dispute arises, and that actions brought after
            that date will be deemed time barred.
          </p>
          <h5>12. Waiver, Severability, and Assignment</h5>
          <p>
            No waiver by BVC of any term or condition set out in these Terms shall
            be deemed a further or continuing waiver of such term or condition or
            a waiver of any other term or condition, and any failure of BVC to
            assert a right or provision under these Terms shall not constitute a
            waiver of such right or provision.
          </p>
          <p>
            If any provision of these Terms is determined to be invalid, illegal,
            or unenforceable for any reason, such provision shall be eliminated or
            limited to the minimum extent such that the remaining provisions of
            the Terms will continue in full force and effect.
          </p>
          <p>
            You may not assign, transfer, or sublicense the rights granted to you
            under these Terms.
          </p>

          <h5>13. Entire Agreement</h5>
          <p>
            These Terms and all terms, policies, and other documents incorporated
            herein, constitute the sole and entire agreement between you and BVC
            regarding the Site and supersede all prior and contemporaneous
            understandings, agreements, representations, and warranties, both
            written and oral, regarding the Site.
          </p>

          <h5>
            1<span>4</span>. Geographic Restrictions
          </h5>
          <p>
            The owner of the Site is based in the state of Florida in the United
            States. We provide this Site for use only by persons located in the
            United States. We make no claims that the Site or any of its Content
            is accessible or appropriate outside of the United State. Access to
            the Site may not be legal by certain persons or in certain countries.
            If you access the Site from outside the United States, you do so on
            your own initiative and are responsible for compliance with local
            laws.
          </p>
          <h5>15. Amendments</h5>
          <p>
            We reserve the right at all times to discontinue or modify any part of
            these Terms in our sole discretion. You agree that any requirement to
            notify you of any such changes to these Terms is satisfied by us
            posting the changes on the first page of these Terms. Any changes to
            these Terms will be effective upon our posting of the notice; provided
            that these changes will be prospective only and not
            retroactive.ACCORDINGLY, EACH TIME YOU SIGN IN TO OR OTHERWISE USE THE
            SITE YOU ARE ENTERING INTO A NEW AGREEMENT WITH US ON THE THEN
            APPLICABLE TERMS AND YOU AGREE THAT WE MAY NOTIFY YOU OF OTHER TERMS
            BY POSTING THEM, OR A LINK TO THEM, ON THE SITE (OR IN ANY OTHER
            REASONABLE MANNER OF NOTICE WHICH WE ELECT), AND THAT YOUR USE OF THE
            SITE AFTER SUCH NEW TERMS HAVE BEEN POSTED CONSTITUTES YOUR GOING
            FORWARD AGREEMENT TO THE OTHER TERMS FOR YOUR NEW USE AND
            TRANSACTIONS. If you do not agree to the changes, you should not use
            the Site, or any services offered through the Site, after the
            effective date of the changes. We suggest that you revisit these Terms
            regularly to ensure that you stay informed of any changes.
          </p>

          <p>
            We may revise and update these Terms from time to time in our sole
            discretion. All changes are effective immediately when we post them
            and apply to all access and use of the Site thereafter. Your continued
            use of our Site shall confirm that you have read, accepted, and agreed
            to be bound by such modifications of the Terms. You are expected to
            check this page from time to time so you are aware of any changes, as
            they are binding on you.
          </p>
          <h5>16. Contact Information</h5>
          <p>
            If you have any questions regarding these Terms, you may contact us at{" "}
            <a
              href="https://mail.google.com/mail/u/0/?view=cm&to=legal@brunovisioncare.com"
              target="blank"
              rel="noopener noreferrer"
            >
              legal@brunovisioncare.com
            </a>
          </p>
        </div>

      </section>
      <FooterBottom />
    </>

  );
};

export default TermsOf;
